import { render } from "./AdminSidebar.vue?vue&type=template&id=7bc332b9"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"

import "./AdminSidebar.vue?vue&type=style&index=0&id=7bc332b9&lang=css"

import exportComponent from "/var/www/html/sekaiichi/smart-art/smart-art-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__